import { cn } from '@/lib/cn'

/** The From Zero wordmark (white FROM / yellow ZERO, transparent). Size via
 *  className height, e.g. `h-16`. */
export function Logo({ className }: { className?: string }) {
  return <img src="/logo.png" alt="From Zero" className={cn('w-auto select-none', className)} draggable={false} />
}
